module.exports = __webpack_public_path__ + "img/IMG_9707.99a05cf3.jpeg";